import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-currency-m',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CurrencyMComponent), multi: true }],
  template: `
    <input
      currencyMask
      [placeholder]="placeholder"
      [options]="{allowNegative: allowNegative, prefix: prefix, thousands: '.', decimal: ',', integerLimit: 2, requireDecimal: true}"
      [ngClass]="{'text-right': align === 'right', 'text-center': align == 'center', 'text-left': align === 'left'}"
      [maxLength]="maxlength"
      [readonly]="readonly"
      [formControl]="control"
      [ngStyle]="{'border': 'none', 'width': '100%'}"
      (blur)="handleBlur()"
    >
  `
})
export class CurrencyMComponent implements ControlValueAccessor {

  @Input() placeholder: string;
  @Input() prefix = 'R$ ';
  @Input() maxlength = '20';
  @Input() allowNegative = true;
  @Input() align: 'right' | 'center' | 'left' = 'center';
  @Input() readonly = false;

  @Output() fieldBlur = new EventEmitter<void>();

  value: number;
  control = new FormControl();
  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(obj: any): void {
    this.control.setValue(obj);
  }

  handleBlur(): void {
    this.onTouched();
    this.fieldBlur.emit();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(value => this.onChange(value));
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
